import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=44554348&lang=pug&"
import script from "./CreateUser.vue?vue&type=script&lang=ts&"
export * from "./CreateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports